// ─────────────────────────────────────────────────────────────────
// Glass-i — PVB / interlayer STOCK API client (Stage INTERLAYER-STOCK-2).
// Read-only over /api/erp/inventory/interlayer-stock/*.
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/inventory/interlayer-stock';
function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}

export const interlayerStockApi = {
  stock:  (params = {}) => client.get(BASE, { params }).then(unwrap),
  ledger: (params = {}) => client.get(`${BASE}/ledger`, { params }).then(unwrap),
  // Manual opening balance / correction — deltaSqm is signed (+add, −reduce).
  adjust: (body = {}) => client.post(`${BASE}/adjust`, body).then(unwrap)
};

export default interlayerStockApi;
